import request from "@/utils/request";

// 列表(主数据列表)
export function loadGroupPurchaseInfoListDataApi(data) {
    return request({
      url: "web/groupPurchaseInfo/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadGroupPurchaseInfoExportDataApi(data) {
    return request({
      url: "web/groupPurchaseInfo/exportData",
      method: "post",
      data
    });
  }
  // 导出图片
  export function loadGroupPurchaseInfoExportPicZipApi(data) {
    return request({
      url: "web/groupPurchaseInfo/exportPicZip",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateGroupPurchaseInfoApi(data) {
    return request({
      url: "web/groupPurchaseInfo/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initGroupPurchaseInfoApi(data) {
    return request({
      url: "web/groupPurchaseInfo/initGroupPurchaseInfo",
      method: "post",
      data
    });
  }
  
  // 下拉列表（下拉选择）
  export function loadGroupPurchaseInfoListApi(data) {
    return request({
      url: "web/groupPurchaseInfo/listSelectData",
      method: "post",
      data
    });
  }

  
// 卷烟明细列表(主数据列表)
export function loadGroupPurchaseInfoDetailListDataApi(data) {
  return request({
    url: "web/groupPurchaseInfoDetail/listData",
    method: "post",
    data
  });
}
// 卷烟明细导出
export function loadGroupPurchaseInfoDetailExportDataApi(data) {
  return request({
    url: "web/groupPurchaseInfoDetail/exportData",
    method: "post",
    data
  });
}
  
// 物料明细列表(主数据列表)
export function loadGroupPurchaseInfoMaterialsDetailListDataApi(data) {
  return request({
    url: "web/groupPurchaseInfoMaterialsDetail/listData",
    method: "post",
    data
  });
}
// 物料明细导出
export function loadGroupPurchaseInfoMaterialsDetailExportDataApi(data) {
  return request({
    url: "web/groupPurchaseInfoMaterialsDetail/exportData",
    method: "post",
    data
  });
}